// removed by extract-text-webpack-plugin
module.exports = {"NoteBody":"NoteBody---2abPP","TimelineAttributes":"TimelineAttributes---_FTAx","NPSEvent":"NPSEvent---1fe6C"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/customer/TimeLine/EventData/style.styl
// module id = i4Ts
// module chunks = 89